import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import moment from 'moment';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { CertificateService } from '../certificates/certificate.service';
import {
  AcceptPolicyPayload,
  EmissionMigrationPayload,
  RecoveryMigrationPayload,
} from './migration.models';

@Injectable({
  providedIn: 'root',
})
export class MigrationeService {
  modalMessageType: 'info' | 'warning' = 'info';
  private migrationModalVisibleSubject = new BehaviorSubject<boolean>(false);
  migrationModalVisible$ = this.migrationModalVisibleSubject.asObservable();

  //TODO: da verificare se baseUrl è corretto
  get baseUrl(): string {
    return `/ncfr-api/v1/certificate/${this.certificateService.certID}/rekey`;
  }

  constructor(
    private httpClient: HttpClient,
    private certificateService: CertificateService,
    private translateService: TranslateService
  ) {}

  //Controlla se la data di migrazione è scaduta o meno e setta il tipo di modale da aprire
  checkMigrationModalType(): 'info' | 'warning' {
    const finalMigrationDateString = this.translateService.instant(
      'MIGRATION_PAGE.EXPIRATION_MIGRATION_DATE'
    );

    const finalMigrationDate = moment(finalMigrationDateString, 'DD/MM/YYYY');
    const today = moment();
    if (today.isSameOrAfter(finalMigrationDate, 'D')) {
      //apriamo modale bloccante
      this.modalMessageType = 'warning';
    } else {
      //apriamo modale non bloccante
      this.modalMessageType = 'info';
    }

    return this.modalMessageType;
  }

  setMigrationModalVisible(visible: boolean): void {
    this.migrationModalVisibleSubject.next(visible);
  }
  // servizio per accettare primi 2 step di Migration
  acceptPrivacyPolicy(payload: AcceptPolicyPayload) {
    //return new Promise(async (resolve, reject) => {
    //console.log('acceptPrivacyPolicy', payload);
    const url = `${this.baseUrl}/approval`;
    console.log('url: ' + url);
    return this.httpClient.post<any>(
      url,
      { ...payload },
      {
        headers: {
          'Content-Type': 'application/json',
          'X-OTP': payload.otp,
          'InfoCert-Correlation-ID': this.certificateService.correlationId,
          plainError: 'true',
        },
      }
    );
  }

  // servizio per accettare gli ultimi 3 step di Migration
  emissionMigration(
    payload: EmissionMigrationPayload,
    forceError = false
  ): Observable<any> {
    if (forceError) {
      return throwError({ codice: 'MT_MIG_001', messaggio: 'Errore forzato' });
    }
    const url = `${this.baseUrl}/enroll`;
    console.log('url: ' + url);
    return this.httpClient.post<any>(
      url,
      { ...payload },
      {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          plainError: 'true',
          'InfoCert-Correlation-ID': this.certificateService.correlationId,
        },
      }
    );
  }

  ricoveryMigration(payload: RecoveryMigrationPayload) {
    const url = `${this.baseUrl}/recover`;
    console.log('url: ' + url);
    return this.httpClient.post<any>(
      url,
      { ...payload },
      {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          plainError: 'true',
          'InfoCert-Correlation-ID': this.certificateService.correlationId,
        },
      }
    );
  }

  //test recovery
  generateError() {
    return new Promise((resolve, reject) => {
      reject('MT_MIG_001');
    });
  }
}
